import { z } from 'zod';
import { entityMetaSchema } from '../../utils';

export const tabBaseSchema = z.object({
    id: z.string(),
    parentId: z.string(),
    children: z.array(z.unknown()),
    entityType: z.literal('tab'),
    version: z.number().int().nonnegative(),
    meta: entityMetaSchema,
});
